import { UploadFileInfo } from '@gsp-svc/formdoc-upload';
import { AttachmentInfo } from './types';

/**
 * éä»¶ä¿¡æ¯å¤çå·¥å·ç±»
 */
class AttachmentUtil {

  /**
   * è½¬æ¢ä¸ºéä»¶ä¿¡æ¯æ°ç»
   */
  public static convertToAttachmentInfos(fileInfos: UploadFileInfo[]): AttachmentInfo[] {
    if (!fileInfos) {
      return [];
    }
    const attachmentInfos: AttachmentInfo[] = fileInfos.map((fileInfo: UploadFileInfo) => {
      return this.convertToAttachmentInfo(fileInfo);
    });
    return attachmentInfos;
  }

  /**
   * è½¬æ¢ä¸ºéä»¶ä¿¡æ¯
   */
  public static convertToAttachmentInfo(fileInfo: UploadFileInfo): AttachmentInfo {
    const attachmentInfo: AttachmentInfo = {
      attachmentId: fileInfo.metadataId,
      fileName: fileInfo.fileName
    };
    return attachmentInfo;
  }

  /**
   * è·åéä»¶åè¡¨ä¸­çç¬¬ä¸ä¸ªéä»¶
   */
  public static getFirstAttachmentInfo(attachmentInfos: AttachmentInfo[]) {
    if (!attachmentInfos || attachmentInfos.length === 0) {
      return;
    }
    const firstAttachmentInfo = attachmentInfos[0];
    return firstAttachmentInfo;
  }

  /**
   * æåéä»¶idæ°ç»
   */
  public static peekAttachmentIds(attachmentInfos: AttachmentInfo[]) {
    if (!attachmentInfos) {
      attachmentInfos = [];
    }
    const attachmentIds = attachmentInfos.map((attachmentInfo: AttachmentInfo) => {
      return attachmentInfo.attachmentId;
    });

    return attachmentIds;
  }

}

export { AttachmentUtil };
